var _APP_CONFIGURATION$co, _APP_CONFIGURATION$co2, _APP_CONFIGURATION$co3, _APP_CONFIGURATION$co4;
import defaultConfig from "../config/app_config/default";
import shopstarConfig from "../config/app_config/shopstar";
import funbankConfig from "../config/app_config/funbank";
import hdfcConfig from "../config/app_config/hdfc";
import bancoGeneralConfig from "../config/app_config/banco-general";
import interbankConfig from "../config/app_config/interbank-benefit";
const getAppConfig = () => {
  switch (process.env.NEXT_PUBLIC_APP_CONFIG) {
    case "shopstar":
      return shopstarConfig;
    case "funbank":
      return funbankConfig;
    case "hdfc":
      return hdfcConfig;
    case "banco-general":
      return bancoGeneralConfig;
    case "demo":
      return shopstarConfig;
    case 'interbank':
      return interbankConfig;
    default:
      return defaultConfig;
  }
};
const APP_CONFIGURATION = getAppConfig();
export default APP_CONFIGURATION;
export const DYNAMIC_COMPONENTS_DEFINITION = [{
  className: "max-width-component",
  definition: APP_CONFIGURATION.config.contentMaxWidthConfig
}, {
  className: "header-dynamic-style",
  definition: APP_CONFIGURATION.config.headerDynamicStyleConfig
}, {
  className: 'flight-header',
  definition: (_APP_CONFIGURATION$co = APP_CONFIGURATION.config.flightConfig) === null || _APP_CONFIGURATION$co === void 0 ? void 0 : _APP_CONFIGURATION$co.headerConfig
}, {
  className: "global-margin",
  definition: APP_CONFIGURATION.config.globalMarginConfig
}, {
  className: "global-responsive-horizontal-paddings",
  definition: APP_CONFIGURATION.config.globalHorizontalPaddingConfig
}, {
  className: "flight-padding",
  definition: APP_CONFIGURATION.config.flightPaddingConfig
}, {
  className: 'default-padding',
  definition: 'p-4 md:px-[150px] md:py-4'
}, {
  className: 'global-bottom-padding',
  definition: 'pb-[100px]'
}, {
  className: 'global-top-padding',
  definition: 'pt-8'
}, {
  className: 'global-card',
  definition: (_APP_CONFIGURATION$co2 = APP_CONFIGURATION.config.globalCardConfig) !== null && _APP_CONFIGURATION$co2 !== void 0 ? _APP_CONFIGURATION$co2 : 'rounded-2xl bg-white border border-neutral-700 box_shadow'
}, {
  className: 'reservation-card',
  definition: (_APP_CONFIGURATION$co3 = APP_CONFIGURATION.config.reservationCardConfig) !== null && _APP_CONFIGURATION$co3 !== void 0 ? _APP_CONFIGURATION$co3 : 'border rounded-2xl border-[#676A6A] flex flex-col sm:flex-row p-8 justify-between gap-10'
}, {
  className: 'hotel-reservation-card',
  definition: (_APP_CONFIGURATION$co4 = APP_CONFIGURATION.config.hotelReservationCardConfig) !== null && _APP_CONFIGURATION$co4 !== void 0 ? _APP_CONFIGURATION$co4 : 'flex flex-col flex-shrink border-[0.5px] border-[#4F4F4F] rounded-lg gap-8 overflow-hidden sm:flex-row'
}];